import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSubjectReportsContext } from "@stores/SubjectReportsContext";
import { useSelectedReport } from "./useSelectedReport";
/**
 * The report list for a community plus the report currently selected on it. Shared by the
 * header dropdown and by the pages that render a report's data, so both read the same answer.
 */
export const useCommunityReportSelection = (communityId) => {
    const { assessmentId } = useParams();
    const { getReports, loadReports, setSelectedReportId } = useSubjectReportsContext();
    const { reports, loading, error } = getReports(communityId);
    // null while it resolves, so the selector does not settle on a fallback and then jump.
    const { selectedReportId, selectReport } = useSelectedReport({
        communityId,
        reports: loading ? null : reports,
    });
    useEffect(() => {
        if (communityId)
            loadReports(communityId);
    }, [communityId, loadReports]);
    // Landing on /overview/:id or /results/:id — by a click, a reload or a shared link — is itself
    // a selection. Recording it keeps the sidebar's two sub-page links pointing at the report the
    // user is actually looking at instead of snapping back to the latest.
    useEffect(() => {
        if (communityId && assessmentId)
            setSelectedReportId(communityId, assessmentId);
    }, [communityId, assessmentId, setSelectedReportId]);
    return { reports, loading, error, selectedReportId, selectReport };
};
